interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
}

export default function SectionHeading({ eyebrow, title, desc, align = 'left' }: SectionHeadingProps) {
  const alignClass = align === 'center' ? 'text-center items-center' : 'text-left items-start';
  return (
    <div className={`flex flex-col ${alignClass} gap-3 mb-8 md:mb-10`}>
      {eyebrow && (
        <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs md:text-sm font-medium text-primary-700">
          <i className="ri-bookmark-3-line"></i>
          {eyebrow}
        </span>
      )}
      <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 leading-tight">{title}</h2>
      {desc && <p className="max-w-2xl text-sm md:text-base text-foreground-600 leading-relaxed">{desc}</p>}
    </div>
  );
}